import Newsletter_44_container from "./container/Newsletter_44_container";
export default Newsletter_44_container;
